import homeProgress0 from 'url:../../../assets/images/home-progress-0.webp';
import lungesVideo from 'url:../../../assets/videos/lunges-video.mp4';
import lunges1 from 'url:../../../assets/images/lunges-1.webp';
import lunges2 from 'url:../../../assets/images/lunges-2.webp';

export const lungesAssets = {
  homeProgress0,
  lungesVideo,
  lunges1,
  lunges2,
} as const;

export const lungesAssetList = Object.values(lungesAssets);
